import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'

import { IDisplayStateProps, IDisplayDispatchProps } from './types'
import { fetchHospitals } from '../../../../store/hospitals/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { fetchPlans } from '../../../../store/plans/actions'
import { IState } from '../../../../store/types'
import { Display } from './Display'

const mapStateToProps = (state: IState): IDisplayStateProps => {
  return {
    hospitals: state.hospitals,
    installations: state.installations,
    plans: state.plans,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IDisplayDispatchProps => {
  return {
    fetchHospitals: () => {
      return dispatch(fetchHospitals())
    },
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    fetchPlans: () => {
      return dispatch(fetchPlans())
    }
  }
}

const DisplayContainer = connect(mapStateToProps, mapDispatchToProps)(Display)

export {
  DisplayContainer
}
